import { render } from "./ForgetPasswordPage.vue?vue&type=template&id=1b7f98aa&scoped=true"
import script from "./ForgetPasswordPage.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordPage.vue?vue&type=script&lang=js"

import "./ForgetPasswordPage.vue?vue&type=style&index=0&id=1b7f98aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b7f98aa"]])

export default __exports__